exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide-nav[data-v-7497348a]{font-family:DMSans-Medium,DMSans;font-weight:500;display:flex}.guide-nav .item[data-v-7497348a]{font-size:.22rem;padding:0 .3rem;line-height:.6rem;cursor:pointer;color:hsla(0,0%,100%,.85)}.guide-nav .active[data-v-7497348a]{color:#fff;position:relative;font-family:DMSans-Bold,DMSans;font-weight:bold}.guide-nav .active[data-v-7497348a]::after{content:\"\";position:absolute;left:.3rem;right:.3rem;bottom:.15rem;height:2px;background:linear-gradient(90deg, #38F4BA 0%, #34DAC5 100%)}", ""]);

// exports
